import tw, { styled } from 'twin.macro';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import classNames from 'classnames';
import { Input } from '../../../components/Forms';
import ButtonLink from '../../../components/ButtonLink';
import FIELDS_LIST from '../../upload/components/fieldsList';

const Wrapper = styled('div')`
  ${tw`flex flex-wrap mx-auto max-w-3xl mb-10`}

  a {
    ${tw`my-0 mx-auto`}
  }
`

const Field = styled('div')`
  ${tw`h-8 w-full sm:w-1/2 md:w-1/3 flex items-center`}
`

const FieldLabel = styled('label')`
  ${tw`font-bold ml-1`}
`

const FieldDetail = styled('div')`
  ${tw`flex items-center -ml-2`}
`

const Leading = styled('h1')`
  ${tw`text-center text-gray-600 text-xl font-light mb-2`};
`

class Lookup extends Component {

	static propTypes = {
		isGeocoding: PropTypes.bool.isRequired,
		onLookup: PropTypes.func.isRequired
	};

  constructor(props) {
    super(props);

    this.queryRef = React.createRef();

    this.state = {
      selectedFields: []
    };
  }

  componentDidMount() {
    const urlParams = new URLSearchParams(window.location.search);
    const query = urlParams.get('q');

    if (query) {
      this.queryRef.current.value = query;
      this.handleLookupSubmit();
    }
  }

	render() {
		const iconClassNames = classNames('fa', this.props.isGeocoding ? 'fa-refresh fa-spin' : 'fa-search');

		return (
			<form onSubmit={this.handleLookupSubmit}>
				<Leading>Please enter an address in the US or Canada</Leading>
        <Wrapper>
          <Input ref={this.queryRef} title="Address Input"/>
        </Wrapper>

				<Leading>Do you want to append additional data?</Leading>
        <Wrapper>
          <div>
          {Object.keys(FIELDS_LIST).map((category, i) => (
            <div tw="flex flex-wrap mb-4">
              {FIELDS_LIST[category].map(field => this.renderField(field, false))}
            </div>
          ))}
          </div>

          <Field>
            <FieldDetail>
              <a href="/guides/data-matching-overview/">Read more about data appends &raquo;</a>
            </FieldDetail>
          </Field>
        </Wrapper>

        <Wrapper>
          <ButtonLink onClick={this.handleLookupSubmit} bold disabled={this.props.isGeocoding}>
            <i className={iconClassNames}></i> Lookup address
          </ButtonLink>
				</Wrapper>
			</form>
		);
	}

	renderField = field => {
    const selected = this.state.selectedFields.indexOf(field.name) !== -1;

    return (
      <Field key={field.name}>
          <input type="checkbox" id={field.name} name={field.name} value={field.name} checked={selected} onChange={e => this.handleFieldChecked(e, field)} />
          <FieldLabel htmlFor={field.name}>
            {this.formatFieldTitle(field.title)}
          </FieldLabel>
      </Field>
    )
  }

  formatFieldTitle(title) {
    if (title.indexOf('(') !== -1) {
      title = title.substr(0, title.indexOf('('));
    }

    title = title.replace('Canadian ', '', title);

    return title;
  }

  handleFieldChecked = (e, field) => {
    if (e.target.checked) {
      this.setState({
        selectedFields: [
          ...this.state.selectedFields,
          field.name
        ]
      });
    } else {
      this.setState({
        selectedFields: this.state.selectedFields.filter(val => val !== field.name)
      });
    }
  }

	handleLookupSubmit = e => {
    if (e) {
  		e.preventDefault();
    }

    const query = this.queryRef.current.value;

    if (query.length > 0) {
      this.props.onLookup(query, this.state.selectedFields, this.detectDirection(query));
    }
	}

  detectDirection(query) {
    const isCoordinate = /^[-+]?([1-8]?\d(\.\d+)?|90(\.0+)?)(,|\s)\s*[-+]?(180(\.0+)?|((1[0-7]\d)|([1-9]?\d))(\.\d+)?)$/.test(query);

    return isCoordinate ? 'reverse' : 'forward';
  }
}

export default Lookup;
